<template lang="html">
  <b-navbar class="fixed-top" toggleable="md" type="dark" variant="info">
    <div class="text-center navbar-brand-wrapper d-flex align-items-top justify-content-center">
      <router-link class="navbar-brand brand-logo" to="/dashboard"><img src="../../assets/images/logo.gif" alt="logo"/></router-link>
      <router-link class="navbar-brand brand-logo-mini" to="/dashboard"><img src="../../assets/images/logo-mini.png" alt="logo"/></router-link>
    </div>
    <div class="navbar-menu-wrapper d-flex align-items-center ml-auto ml-lg-0">
      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown right class="preview-list">
          <template slot="button-content">
            <img v-if="this.user.profile_image" :src="this.user.profile_image" class="img-xs rounded-circle" alt="profile image" />
            <img src="../../assets/images/faces/avatardefault.png" class="img-xs rounded-circle" alt="profile image" v-else />
          </template>
          <b-dropdown-item @click="updateProfile" class="preview-item flex-wrap">Profile</b-dropdown-item>
          <b-dropdown-item @click="logout" class="preview-item flex-wrap">Signout</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
      <button class="navbar-toggler navbar-toggler-right align-self-center" type="button" @click="collapedMobileSidebar()">
        <span class="mdi mdi-menu"></span>
      </button>
    </div>
  </b-navbar>
</template>

<script lang="js">
import Axios from "axios";
import { Config } from "../../shared/config";
export default {
  name: 'app-header',
  data () {
    return {
      user:{
          name:'',
          profile_image:'',
      },
    }
  },  
  methods: {
    collapedMobileSidebar: () => {
      document.querySelector('.sidebar').classList.toggle('active')
    },
    updateProfile(){
      this.$router.push("/user/profile");
    },
    logout() {
      Axios.get(Config.apiUrl + "logout")
        .then(() => {
          localStorage.removeItem("userToken");
          this.$router.push("/");
        })
        .catch(error => {
          if (error.data) {
            if (error.data.message) {
              localStorage.removeItem("userToken");
              this.$router.push("/");
            }
          }
        });
    }
  },
  mounted() {
    window.addEventListener('user-localstorage-changed', (event) => {
      this.user = JSON.parse(event.detail.storage);
    });
  },

  created:function(){
    this.user = JSON.parse(localStorage.getItem("user"));
    // this.user.profile_image = this.user.profile_image ? this.user.profile_image : '../../assets/images/faces/avatardefault.png';
  }
}
</script>

<style scoped lang="scss">
.app-header {
}
</style>



// WEBPACK FOOTER //
// src/components/partials/AppHeader.vue